import React from "react";

const Section7Sharing = () => (
  <>
    <h2>7. Intellectual Property Rights</h2>
    <p>
      Comparedly Ltd. owns and retains all rights, title, and interest in and to the Service, including all Intellectual Property Rights related to the software, technology, and content provided as part of the Service. You retain ownership of the Content you provide to the Service.
    </p>

    <p>
      Regarding analytics data and reports generated by Comparedly.com, Comparedly Ltd. claims ownership of the compilation and arrangement of the data within the reports. You are granted a license to use these reports for your internal business purposes during the Subscription Term. You agree not to reproduce, distribute, modify, or create derivative works of the Service or any content provided by Comparedly.com without our express written consent.
    </p>

    <p>
      By submitting Content to the Service, you grant Comparedly Ltd. a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, adapt, publish, translate, distribute, and display such Content as necessary to provide the Service to you. You represent and warrant that you have all necessary rights to grant this license.
    </p>

    <p>
      You shall not infringe upon Comparedly Ltd.'s Intellectual Property Rights, including by copying, modifying, or distributing the software or any part thereof without our explicit permission.
    </p>


  </>
);

export default Section7Sharing;
